const Button = {
   baseStyle: {
      fontWeight: 'normal',
      textDecoration: 'none',
   },
   defaultProps: {
      variant: 'outline',
   },
   sizes: {
      sm: {
         fontSize: '13px',
         height: '30px',
         py: '5px',
         px: '10px',
      },
   },
   variants: {
      outline: {
         bgColor: 'white',
         color: 'gray.800',
      },
   },
};

export default Button;
